import type { AppDispatch } from '@/state/store'
import type { RootState } from '@/state/reducer'
import { useDispatch, useSelector } from 'react-redux'

export const useAppDispatch = useDispatch.withTypes<AppDispatch>()
export const useAppSelector = useSelector.withTypes<RootState>()
